import { Routes, Route } from "react-router-dom";
import { Shell } from "@/components/layout/shell";
import Dashboard from "@/pages/Dashboard";
import AppDetail from "@/pages/AppDetail";
import GitOpsForm from "@/pages/GitOpsForm";
import Backups from "@/pages/Backups";
import BackupOperation from "@/pages/BackupOperation";
import ClusterDetail from "@/pages/ClusterDetail";
import { LogsViewer } from "@/features/logs/LogsViewer";
import { PageHeader } from "@/components/shared/page-header";
import UsersPage from "@/pages/Users";
import UserDetail from "@/pages/UserDetail";
import Organizations from "@/pages/Organizations";
import OrganizationDetail from "@/pages/OrganizationDetail";
import OrgStructure from "@/pages/OrgStructure";
import AppRoles from "@/pages/AppRoles";
import AppRoleDetail from "@/pages/AppRoleDetail";
import AccessMatrix from "@/pages/AccessMatrix";
import Groups from "@/pages/Groups";
import GroupDetail from "@/pages/GroupDetail";
import GatewayRoutes from "@/pages/GatewayRoutes";
import Environments from "@/pages/Environments";

function ComingSoon({ title }: { title: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <h1 className="text-[17px] font-semibold text-foreground mb-2">{title}</h1>
      <p className="text-muted-foreground">Скоро появится.</p>
    </div>
  );
}

function App() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/apps/:name" element={<AppDetail />} />
        <Route path="/apps/:name/gitops" element={<GitOpsForm />} />
        <Route
          path="/logs"
          element={
            <div className="space-y-4">
              <PageHeader title="Журналы" description="Поиск и просмотр журналов всего кластера." />
              <LogsViewer defaultMode="history" />
            </div>
          }
        />
        <Route path="/backups" element={<Backups />} />
        <Route path="/backups/clusters/:ns/:name" element={<ClusterDetail />} />
        <Route path="/backups/operations/:id" element={<BackupOperation />} />
        <Route path="/organizations" element={<Organizations />} />
        <Route path="/organizations/:id" element={<OrganizationDetail />} />
        <Route path="/org-structure" element={<OrgStructure />} />
        <Route path="/org-structure/:unitId" element={<OrgStructure />} />
        <Route path="/app-roles" element={<AppRoles />} />
        <Route path="/app-roles/:name" element={<AppRoleDetail />} />
        <Route path="/access-matrix" element={<AccessMatrix />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/groups/:id" element={<GroupDetail />} />
        <Route path="/gateway-routes" element={<GatewayRoutes />} />
        <Route path="/environments" element={<Environments />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/users/:id" element={<UserDetail />} />
        <Route path="/gitops" element={<ComingSoon title="Запросы GitOps" />} />
      </Routes>
    </Shell>
  );
}

export default App;
